<template>
  <SelectList
    v-model="selectedRegion"
    clearable
    dense
    :disable="disabled"
    :emit-label="false"
    filled
    label="Select Region"
    option-label="label"
    option-value="value"
    :options="regions"
    :rules="rules"
    square
  />
</template>

<script>
import { regions } from "shared/constants";

import SelectList from "src/components/common/SelectList.vue";

export default {
  name: "RegionDropdown",
  components: {
    SelectList,
  },
  props: {
    modelValue: {
      type: String,
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      regions,
    };
  },
  computed: {
    selectedRegion: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>
